import React, { FunctionComponent, useRef } from "react";
import { makeStyles } from "tss-react/mui";
import {
    AppBar,
    Dialog,
    DialogContent,
    FormControl,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    Theme,
    Toolbar,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import Input from "@mui/material/Input";
import { DISPO_SEARCH } from "@/Redux/Disposition/Constants";
import { useAppDispatch } from "@/Redux/Redux";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface SearchModalProps {
    open: boolean;
    handleClose: () => void;
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },

    submit: {
        margin: theme.spacing(3, 0, 2),
    },

    buttonProgress: {
        position: "absolute",
        top: "54%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },

    wrapper: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(2),
        position: "relative",
    },

    appBar: {
        position: "relative",
        boxShadow: "none",
    },

    title: {
        flex: 1,
    },
}));

const SearchModal: FunctionComponent<SearchModalProps> = ({
    open,
    handleClose,
}): JSX.Element => {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const searchForVehicleInput = useRef(null);
    const searchForBookingInput = useRef(null);

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            maxWidth={"sm"}
            fullWidth={true}
        >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <Typography variant="h6" className={classes.title}>
                        Suche
                    </Typography>
                    <IconButton aria-label="close" onClick={handleClose} data-testid={"closeDispoSearch"}>
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <DialogContent style={{ textAlign: "center" }}>
                <Grid container spacing={0} style={{ marginBottom: 15 }}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="standard-adornment-password">
                                {t("disposition.controls.searchModal.vehicleCharacteristics")}

                            </InputLabel>
                            <Input
                                id="standard-adornment-password"
                                inputRef={searchForVehicleInput}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => {
                                                dispatch({
                                                    type: DISPO_SEARCH,
                                                    payload: {
                                                        // @ts-ignore
                                                        searchForVehicle:
                                                            searchForVehicleInput
                                                                ?.current.value,
                                                    },
                                                });
                                                handleClose();
                                            }}
                                        >
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container spacing={0} style={{ marginBottom: 15 }}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="standard-adornment-password">
                                {t("disposition.controls.searchModal.customerContractReservation")}
                            </InputLabel>
                            <Input
                                id="standard-adornment-password"
                                inputRef={searchForBookingInput}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => {
                                                // @ts-ignore
                                                dispatch({
                                                    type: DISPO_SEARCH,
                                                    payload: {
                                                        // @ts-ignore
                                                        searchForBooking:
                                                            searchForBookingInput
                                                                .current.value,
                                                    },
                                                });
                                                handleClose();
                                            }}
                                        >
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default SearchModal;
